import cartState from "./conversion-flow.cart-state.js";
import { buildDogLineItemProperties } from "./conversion-flow.klaviyo.js";

class CFCta extends HTMLElement {
  #elementOriginalPrice;
  #elementPrice;
  #elementOneTimePrice;
  #elementBtnPlan;
  #elementBtnOneTime;

  #priceDetailsKibble = {};
  #priceDetailsFresh = {};
  #priceDetailsTopping = {};

  constructor() {
    super();
    this.startPlan = this.startPlan.bind(this);
    this.buyOneTime = this.buyOneTime.bind(this);
  }

  connectedCallback() {
    this.render();

    cartState.subscribe((state) => {
      if (state.KIBBLE != null) this.#priceDetailsKibble = state.KIBBLE;
      if (state.FRESH != null) this.#priceDetailsFresh = state.FRESH;
      if (state.TOPPING != null) this.#priceDetailsTopping = state.TOPPING;
      this.updateCtaPrices();
    });
  }

  updateCtaPrices() {
    let originalPrice = 0;
    let price = 0;
    if (this.#priceDetailsKibble.checked) {
      originalPrice += this.#priceDetailsKibble.original_price;
      price += this.#priceDetailsKibble.price;
    }
    if (this.#priceDetailsFresh.checked) {
      originalPrice += this.#priceDetailsFresh.original_price;
      price += this.#priceDetailsFresh.price;
    }
    if (this.#priceDetailsTopping.checked) {
      originalPrice += this.#priceDetailsTopping.original_price;
      price += this.#priceDetailsTopping.price;
    }
    this.#elementOriginalPrice.textContent = `€${(originalPrice / 100).toFixed(2).replace(".", ",")}`;
    this.#elementPrice.textContent = `€${(price / 100).toFixed(2).replace(".", ",")}`;
    this.#elementOneTimePrice.textContent = `€${(originalPrice / 100).toFixed(2).replace(".", ",")}`;

    const noneChecked =
      !this.#priceDetailsKibble.checked &&
      !this.#priceDetailsFresh.checked &&
      !this.#priceDetailsTopping.checked;
    this.#elementBtnPlan.disabled = noneChecked;
    this.#elementBtnOneTime.disabled = noneChecked;
  }

  render() {
    this.innerHTML = html`
      <div class="product-subscription-banner">
        <div class="product-subscription-info">
          <div class="first-row">
            <div class="subscription-check">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_438_728)">
                  <path
                    d="M2 6.65625L4.84375 9.5L11.3438 3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_438_728">
                    <rect width="13" height="13" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span class="subscribe-save">Subscrever e poupar</span>
            <div class="subscribe-checks">
              <div class="subscribe-checks-item">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_438_728)">
                    <path
                      d="M2 6.65625L4.84375 9.5L11.3438 3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_438_728">
                      <rect width="13" height="13" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>Cancela a qualquer momento</span>
              </div>
              <div class="subscribe-checks-item">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_438_728)">
                    <path
                      d="M2 6.65625L4.84375 9.5L11.3438 3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_438_728">
                      <rect width="13" height="13" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>Ajusta quando quiseres</span>
              </div>
              <div class="subscribe-checks-item">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_438_728)">
                    <path
                      d="M2 6.65625L4.84375 9.5L11.3438 3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_438_728">
                      <rect width="13" height="13" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>Garantia de 30 dias</span>
              </div>
            </div>
          </div>
          <div class="second-row">
            <div class="second-row-item">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_438_750)">
                  <path
                    d="M12 13.5V2.5C12 1.94772 11.5523 1.5 11 1.5L5 1.5C4.44772 1.5 4 1.94772 4 2.5L4 13.5C4 14.0523 4.44772 14.5 5 14.5H11C11.5523 14.5 12 14.0523 12 13.5Z"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 3.5H10"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_438_750">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span> Monitorização completa com a app Barkyn Health </span>
            </div>
            <div class="second-row-item">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_438_756)">
                  <path
                    d="M13 10.75C13.4142 10.75 13.75 10.4142 13.75 10C13.75 9.58579 13.4142 9.25 13 9.25C12.5858 9.25 12.25 9.58579 12.25 10C12.25 10.4142 12.5858 10.75 13 10.75Z"
                    fill="black"
                  />
                  <path
                    d="M13 12C14.1046 12 15 11.1046 15 10C15 8.89543 14.1046 8 13 8C11.8954 8 11 8.89543 11 10C11 11.1046 11.8954 12 13 12Z"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.5 9V12C6.5 12.663 6.76339 13.2989 7.23223 13.7678C7.70107 14.2366 8.33696 14.5 9 14.5H10.5C11.163 14.5 11.7989 14.2366 12.2678 13.7678C12.7366 13.2989 13 12.663 13 12"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.5 2.5H10V5.44812C10 7.37125 8.47 8.975 6.54625 9C6.08275 9.00613 5.62264 8.92012 5.19265 8.74697C4.76266 8.57382 4.37134 8.31699 4.04142 7.99137C3.7115 7.66575 3.44955 7.27784 3.27078 6.85016C3.092 6.42248 2.99996 5.96354 3 5.5V2.5H4.5"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_438_756">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span> Check-ins semanais com veterinário </span>
            </div>
          </div>
        </div>

        <div class="banner-footer">
          <div class="price-info">
            <span class="original-price">€0,00</span>
            <span class="discounted-price">€0,00</span>
          </div>

          <div class="subscription-cta">
            <button class="start-plan-cta">Avançar</button>
          </div>
        </div>
      </div>

      <div class="product-one-time-banner">
        <span class="title"> Compra única </span>
        <span class="subtitle">
          Nutrição inteligente para longevidade com 30 ingredientes funcionais.
        </span>
        <div class="banner-footer">
          <span class="price"> €0,00 </span>
          <button class="one-time-cta">Avançar</button>
        </div>
      </div>
    `;

    this.#elementOriginalPrice = this.querySelector(
      ".banner-footer .original-price",
    );
    this.#elementPrice = this.querySelector(".banner-footer .discounted-price");
    this.#elementOneTimePrice = this.querySelector(".banner-footer .price");

    this.#elementBtnPlan = this.querySelector(".start-plan-cta");
    this.#elementBtnOneTime = this.querySelector(".one-time-cta");

    this.#elementBtnPlan.addEventListener("click", this.startPlan);
    this.#elementBtnOneTime.addEventListener("click", this.buyOneTime);
  }

  async startPlan() {
    this.#elementBtnPlan.disabled = true;
    this.#elementBtnOneTime.disabled = true;
    const quizAnswers = QuizStorage.getQuizAnswers();
    if (quizAnswers?.email)
      localStorage.setItem("checkout_email", quizAnswers.email);
    await this.clearCart();
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: this.prepareItemsCart(true, quizAnswers),
        attributes: this.#buildCartAttributes(),
      }),
    });
    await this.#navigateToCheckout("/checkout");
  }

  async buyOneTime() {
    this.#elementBtnPlan.disabled = true;
    this.#elementBtnOneTime.disabled = true;
    const quizAnswers = QuizStorage.getQuizAnswers();
    if (quizAnswers?.email)
      localStorage.setItem("checkout_email", quizAnswers.email);
    await this.clearCart();
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: this.prepareItemsCart(false, quizAnswers),
        attributes: this.#buildCartAttributes(),
      }),
    });
    await this.#navigateToCheckout("/checkout");
  }

  #buildCartAttributes() {
    return {
      formId: "pt-" + crypto.randomUUID(),
      order_trial: null,
      external_variant_id: null,
      external_product_id: null,
      subscription_price: null,
      dog_weight: null,
    };
  }

  async #navigateToCheckout(url) {
    try {
      const resolved = await fetch(url, { redirect: "follow", credentials: "include" });
      if (resolved && resolved.url && resolved.url !== url) {
        window.location.href = resolved.url;
        return;
      }
    } catch (e) {
      console.warn("[cf-cta] checkout URL resolve failed:", e);
    }
    window.location.href = url;
  }

  prepareItemsCart(includeSellingPlan = false, quizAnswers = null) {
    const dogProperties = buildDogLineItemProperties(quizAnswers);
    const items = [];
    if (this.#priceDetailsKibble.checked) {
      items.push({
        id: this.#priceDetailsKibble.variantId,
        quantity: this.#priceDetailsKibble.quantity,
        selling_plan: includeSellingPlan
          ? this.#priceDetailsKibble.selling_plan
          : undefined,
        properties: dogProperties,
      });
    }
    if (this.#priceDetailsFresh.checked) {
      items.push({
        id: this.#priceDetailsFresh.variantId,
        quantity: this.#priceDetailsFresh.quantity,
        selling_plan: includeSellingPlan
          ? this.#priceDetailsFresh.selling_plan
          : undefined,
        properties: dogProperties,
      });
    }
    if (this.#priceDetailsTopping.checked) {
      items.push({
        id: this.#priceDetailsTopping.variantId,
        quantity: this.#priceDetailsTopping.quantity,
        selling_plan: includeSellingPlan
          ? this.#priceDetailsTopping.selling_plan
          : undefined,
        properties: dogProperties,
      });
    }
    return items;
  }

  async clearCart() {
    return await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
  }
}

if (!customElements.get("cf-cta")) {
  customElements.define("cf-cta", CFCta);
}
